import React from 'react';
import './index.css';
import {  Routes, Route } from "react-router-dom";
import NotFound from './components/NotFound';
import Slimetics from './pages/Slimetics';
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Slimetics/>} />
        <Route path="*" element={<NotFound />} />
      </Routes>

    </div>
  );
}

export default App;